<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center"
  >
    <div class="fixed inset-0 bg-gray-500 opacity-75" @click="close"></div>
    <div
      class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
    >
      <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Manage Saved Replies
            </h3>
            <div class="mt-4">
              <ul role="list" class="space-y-3">
                <li v-if="savedReplies.length === 0" class="text-gray-500">
                  No saved replies added. Once you add saved replies you can
                  manage it here.
                </li>
                <li
                  v-for="reply in savedReplies"
                  :key="reply.id"
                  class="overflow-hidden rounded-md bg-white px-6 py-4 shadow justify-between flex hover:bg-gray-100"
                >
                  <div>
                    <h3>{{ reply.name }}</h3>
                    <p>{{ reply.content }}</p>
                  </div>
                  <button
                    class="text-red-600 hover:text-red-800"
                    @click="deleteReply(reply.id)"
                  >
                    Delete
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
          @click="close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState("Inbox", ["savedReplies"])
  },
  methods: {
    ...mapActions("Inbox", ["deleteSavedReply"]),
    close() {
      this.$emit("close");
    },
    deleteReply(replyId) {
      this.deleteSavedReply(replyId).then(() => {
        // Optionally emit an event or handle post-deletion logic
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
